import React, { Fragment } from 'react';
import ErrorStateCard from '../../atoms/cards/error-state-card/ErrorStateCard';

export type ErrorBoundaryProps = React.PropsWithChildren<{
  fallback?: (props: { disableErrorState: () => void }) => React.ReactNode;
  className?: string;
}>;

type ErrorBoundaryState = { hasError: boolean; errorCount: number };

// https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false, errorCount: 0 };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error("Une erreur est survenue dans l'application", error);
  }

  render() {
    if (this.state.hasError) {
      const disableErrorState = () =>
        this.setState({ hasError: false, errorCount: this.state.errorCount + 1 });

      if (this.props.fallback) {
        return this.props.fallback({ disableErrorState });
      }

      return (
        <ErrorStateCard onRetry={disableErrorState} className={this.props.className} />
      );
    }

    return <Fragment key={this.state.errorCount}>{this.props.children}</Fragment>;
  }
}
